import { render, staticRenderFns } from "./CreditPackages.vue?vue&type=template&id=513d4b1b&"
import script from "./CreditPackages.vue?vue&type=script&lang=js&"
export * from "./CreditPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports